import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=77f0c8b1&scoped=true&"
var script = {}
import style0 from "./OurStory.vue?vue&type=style&index=0&id=77f0c8b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0c8b1",
  null
  
)

export default component.exports